import _defineProperty from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Wed Dec 05 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { OrderedMap } from 'immutable';
import { GridSettings, Utils } from '@logio/common-be-fe';
import { GridApi, ColumnApi } from 'ag-grid-community';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import { action, observable, runInAction } from 'mobx';
import logger from '../../../shared/logger';
import { GridSettingsLayer } from '../../../shared/transportLayers/grid-settings/GridSettingsLayer';
import GridViewApi from './GridViewApi';
/** Main mobx store for our internal AgGrid (wrapper) component */

var AgGridStore =
/*#__PURE__*/
function () {
  function AgGridStore(gridId) {
    var _this = this;

    _classCallCheck(this, AgGridStore);

    this.gridId = gridId;
    this.gridApi = null;
    this.gridColumnApi = null;
    this.gridViewApi = null;
    this.gridSettings = OrderedMap();
    this.activeGridSettingsId = null;
    this.gridSettingsModalVisible = false;
    this.showAggRow = false;
    this.showBulkRow = false;
    this.invalid = false;
    this.selectedRows = [];
    this.gridSettingsLayer = new GridSettingsLayer();
    this.gridSettingJustChanged = false;
    this.skipColumnsChangeEvent = false;

    this.findGridSettingsByParentId = function (parentId) {
      return _this.gridSettings.find(function (gs) {
        return gs.parentId === parentId;
      });
    };

    this.createGridSettingsByParent = function (pgs) {
      var settings = {
        columnState: _this.gridColumnApi.getColumnState(),
        filterModel: _this.gridApi.getFilterModel(),
        sortModel: _this.gridApi.getSortModel()
      };
      return new GridSettings(Utils.VOID_ID, pgs.id, pgs.userId, _this.gridId, pgs.icon, pgs.name, pgs.shared, settings);
    };

    this.gridSettingReset = function (event) {
      _this.gridViewApi.triggerSettingsReset();

      _this.activeGridSettingsId = null;
      event.preventDefault();

      _this.doGridSettingsReset();
    };

    this.doGridSettingsReset = function () {
      _this.gridApi.setFilterModel([]);

      _this.gridApi.setSortModel([]);

      _this.gridColumnApi.resetColumnState();

      _this.gridColumnApi.resetColumnGroupState();
    };

    this.gridSettingModalNew = function (event) {
      event.preventDefault();
      _this.gridSettingsModalVisible = true;
      _this.activeGridSettingsId = null;
    };

    this.gridSettingModalEdit = function (gridSettingsId) {
      _this.gridSettingsModalVisible = true;
      _this.activeGridSettingsId = gridSettingsId;
    };

    this.gridSettingModalSubmit = function (gridSetting) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var gridSettingId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.gridSettingsModalVisible = false;
                _context.next = 3;
                return this.gridSettingSave(gridSetting);

              case 3:
                gridSettingId = _context.sent;
                runInAction(function () {
                  _this2.activeGridSettingsId = gridSettingId;
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    this.gridSettingSwitch = function (gridSettingId) {
      _this.gridViewApi.triggerSettingsSwitch(gridSettingId);

      _this.gridSettingJustChanged = true;
      _this.activeGridSettingsId = gridSettingId;

      var settings = _this.gridSettings.get(gridSettingId).settings;

      setTimeout(function () {
        _this.gridApi.setSortModel([]);

        _this.gridApi.setFilterModel({});

        _this.gridColumnApi.setColumnState([]);

        _this.gridColumnApi.setColumnState(settings.columnState);

        _this.gridApi.setFilterModel(settings.filterModel);

        _this.gridApi.setSortModel(settings.sortModel, 'api');
      }, 1);
    };

    this.toggleGridSettingModalVisible = function () {
      _this.gridSettingsModalVisible = !_this.gridSettingsModalVisible;
    };
    /**
     * Checks if the loaded GridSettings has the same columns as the rendered AgGrid
     */


    this.isSettingsValid = function (settings) {
      if (settings) {
        if (settings.sortModel && settings.columnState) {
          var loadedColIds = settings.columnState.map(function (c) {
            return c.colId;
          }).sort();

          var actualColIds = _this.gridColumnApi.getColumnState().map(function (c) {
            return c.colId;
          }).sort(); // Check if the loaded model is the same as the actual (same column names, same columns count)


          if (loadedColIds.length === actualColIds.length && isEqual(loadedColIds, actualColIds)) {
            return true;
          } else {
            logger.info('Columns setting not loaded due the column model change.');
          }
        }
      }

      return false;
    };

    this.gridSettingDelete = function (gridSettingId) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.gridViewApi.triggerSettingsDelete(gridSettingId);
                this.gridSettingsModalVisible = false;
                this.activeGridSettingsId = null;
                _context2.next = 5;
                return this.gridSettingsLayer.delete(gridSettingId);

              case 5:
                result = _context2.sent;

                if (result) {
                  runInAction(function () {
                    _this3.gridSettings = _this3.gridSettings.delete(gridSettingId);
                  });
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    this.gridSettingUpdate = function (gridSetting) {
      if (gridSetting) {
        gridSetting = _this.normalizeSettings(gridSetting);

        if (gridSetting.name === null && gridSetting.icon === null) {
          _this.defaultGridSettings = gridSetting;
        } else {
          _this.gridSettings = _this.gridSettings.set(gridSetting.id, gridSetting);
        }
      }
    };
    /**
     * Deletes additional default grid settings from db if exists
     * @param gridSettings
     */


    this.clearGridSettings = function (gridSettings) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var filteredGridSettings, gridSetting, i;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                filteredGridSettings = gridSettings.filter(function (gs) {
                  return gs.name === null && gs.icon === null;
                });

                if (!(filteredGridSettings.length === 1)) {
                  _context3.next = 5;
                  break;
                }

                gridSetting = filteredGridSettings[0];
                _context3.next = 14;
                break;

              case 5:
                if (!(filteredGridSettings.length > 1)) {
                  _context3.next = 14;
                  break;
                }

                gridSetting = filteredGridSettings[filteredGridSettings.length - 1];
                i = 0;

              case 8:
                if (!(i < filteredGridSettings.length - 1)) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 11;
                return this.gridSettingsLayer.delete(filteredGridSettings[i].id);

              case 11:
                i++;
                _context3.next = 8;
                break;

              case 14:
                return _context3.abrupt("return", gridSetting);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Checks if all column exists in columnState, adds missing columns and removes additional columns
     * @param gridSettings
     */


    this.checkColumnState = function (gridSettings) {
      if (gridSettings) {
        var defaultColumns = _this.gridColumnApi.getAllGridColumns(); // Check default columns with loaded gridSettings columnState, if column not found adds i to columnState


        defaultColumns.forEach(function (defaultColumn) {
          var colId = defaultColumn.getColId();
          var foundColumn = gridSettings.settings.columnState.find(function (defaultSettingColumnState) {
            return defaultSettingColumnState.colId === colId;
          });

          if (!foundColumn) {
            gridSettings.settings.columnState.push({
              colId: colId,
              hide: false,
              aggFunc: null,
              pinned: null,
              pivotIndex: null
            });
          }
        }); // Removes additional columns in loaded gridSettings

        var cleanedSettings = gridSettings.settings.columnState.filter(function (defaultColumnState) {
          var foundCol = defaultColumns.find(function (defaultColumn) {
            return defaultColumn.getColId() === defaultColumnState.colId;
          });

          if (foundCol) {
            return defaultColumnState;
          }
        });
        gridSettings.settings.columnState = cleanedSettings;
      }
    };

    this.gridSettingSave = function (gridSetting) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var gs, _gs;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!gridSetting.id) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 3;
                return this.gridSettingsLayer.update(gridSetting);

              case 3:
                gs = _context4.sent;
                this.gridSettingUpdate(gs);
                this.gridViewApi.triggerSettingsUpdate(gs);
                return _context4.abrupt("return", gs.id);

              case 9:
                _context4.next = 11;
                return this.gridSettingsLayer.create(gridSetting);

              case 11:
                _gs = _context4.sent;
                this.gridSettingUpdate(_gs);
                this.gridViewApi.triggerSettingsCreate(_gs);
                return _context4.abrupt("return", _gs.id);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };

    this.gridSettingsAddEventListeners = function () {
      _this.gridApi.addEventListener('sortChanged', _this.onColumnsSettingsChanged);

      _this.gridApi.addEventListener('columnMoved', _this.onColumnsSettingsChanged);

      _this.gridApi.addEventListener('columnVisible', _this.onColumnsSettingsChanged);

      _this.gridApi.addEventListener('columnResized', _this.onColumnResized);

      _this.gridApi.addEventListener('filterChanged', _this.onFilterChangedDebounced);
    };

    this.gridSettingsRemoveEventListeners = function () {
      // We need to check existence of gridApi in case of Ag-Grid componentDidUnmount call before onGridReady callback.
      if (!Utils.isValueMissing(_this.gridApi)) {
        _this.gridApi.removeEventListener('sortChanged', _this.onColumnsSettingsChanged);

        _this.gridApi.removeEventListener('columnMoved', _this.onColumnsSettingsChanged);

        _this.gridApi.removeEventListener('columnVisible', _this.onColumnsSettingsChanged);

        _this.gridApi.removeEventListener('columnResized', _this.onColumnResized);

        _this.gridApi.removeEventListener('filterChanged', _this.onFilterChangedDebounced);
      }
    };
    /**
     * Loads all users settings from the BE
     */


    this.gridSettingsLoad = function () {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this4 = this;

        var gridSettings, defaultGridSetting, savedViewsGridSettings, settings, animalId;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.gridId && this.gridApi && this.gridColumnApi)) {
                  _context5.next = 26;
                  break;
                }

                _context5.prev = 1;
                _context5.next = 4;
                return this.gridSettingsLayer.getAll(this.gridId);

              case 4:
                gridSettings = _context5.sent;
                _context5.next = 7;
                return this.clearGridSettings(gridSettings);

              case 7:
                defaultGridSetting = _context5.sent;
                savedViewsGridSettings = gridSettings.filter(function (gs) {
                  return gs.name !== null && gs.icon !== null;
                });
                [defaultGridSetting].concat(_toConsumableArray(savedViewsGridSettings)).forEach(this.gridSettingUpdate);
                this.checkColumnState(this.defaultGridSettings);
                this.gridSettings.forEach(this.checkColumnState);

                if (!this.defaultGridSettings) {
                  _context5.next = 19;
                  break;
                }

                settings = this.defaultGridSettings.settings;
                animalId = this.findAnimalIdByGridSetting(settings);

                if (animalId) {
                  runInAction(function () {
                    _this4.activeGridSettingsId = animalId;
                  });
                }

                this.gridColumnApi.setColumnState(settings.columnState);
                _context5.next = 19;
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    if (Object.keys(settings.filterModel).length > 0) {
                      _this4.gridApi.setFilterModel(settings.filterModel);
                    }

                    if (settings.sortModel.length > 0) {
                      _this4.gridApi.setSortModel(settings.sortModel, 'api');
                    }

                    resolve();
                  }, 1);
                });

              case 19:
                this.gridSettingsAddEventListeners();
                _context5.next = 26;
                break;

              case 22:
                _context5.prev = 22;
                _context5.t0 = _context5["catch"](1);
                console.log(_context5.t0);
                logger.error('Columns settings not loaded due the network error');

              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 22]]);
      }));
    };
    /**
     * Called when column sorting is changed, column is showed / hided, resized or moved
     */


    this.onColumnsSettingsChanged = function () {
      if (_this.gridSettingSaveTimeout) {
        clearTimeout(_this.gridSettingSaveTimeout);
      }

      if (!_this.gridSettingJustChanged) {
        runInAction(function () {
          _this.activeGridSettingsId = null;
        });
      }

      _this.gridSettingSaveTimeout = setTimeout(function () {
        return __awaiter(_this, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6() {
          var settings;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!this.skipColumnsChangeEvent) {
                    _context6.next = 3;
                    break;
                  }

                  this.skipColumnsChangeEvent = false;
                  return _context6.abrupt("return");

                case 3:
                  if (!(this.gridId && this.gridApi && this.gridColumnApi)) {
                    _context6.next = 13;
                    break;
                  }

                  settings = {
                    columnState: this.gridColumnApi.getColumnState(),
                    filterModel: this.gridApi.getFilterModel(),
                    sortModel: this.gridApi.getSortModel()
                  };

                  if (!this.defaultGridSettings) {
                    _context6.next = 11;
                    break;
                  }

                  if (isEqual(this.defaultGridSettings.settings, settings)) {
                    _context6.next = 9;
                    break;
                  }

                  _context6.next = 9;
                  return this.gridSettingSave(this.defaultGridSettings.copy('settings', settings));

                case 9:
                  _context6.next = 13;
                  break;

                case 11:
                  _context6.next = 13;
                  return this.gridSettingSave(new GridSettings(Utils.VOID_ID, null, Utils.VOID_ID, this.gridId, null, null, false, settings));

                case 13:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
      }, 500);
    };

    this.onFilterChanged = function () {
      _this.onColumnsSettingsChanged();

      _this.gridSettingJustChanged = false;
    };
    /**
     * onFilterChanged is sometimes called multiple times on saved filter switch
     */


    this.onFilterChangedDebounced = debounce(this.onFilterChanged, 1);

    this.onColumnResized = function (event) {
      if (event.finished) {
        _this.onColumnsSettingsChanged();
      }
    };
    /**
     *  Normalizes specific settings
     *  - Shows actions column and pinned it to left side of grid
     *  - Remove unused column definitions
     */


    this.normalizeSettings = function (gridSetting) {
      gridSetting.settings.columnState = gridSetting.settings.columnState.map(function (s) {
        if (!_this.gridColumnApi.getColumn(s.colId)) {
          return;
        }

        if (s.colId === 'actions') {
          s.hide = false;
          s.pinned = 'left';
        }

        return s;
      }).filter(function (s) {
        return !!s;
      });
      gridSetting.settings.sortModel = gridSetting.settings.sortModel.map(function (s) {
        if (!_this.gridColumnApi.getColumn(s.colId)) {
          return;
        }

        return s;
      }).filter(function (s) {
        return !!s;
      });
      gridSetting.settings.filterModel = Object.keys(gridSetting.settings.filterModel).reduce(function (acc, cur) {
        if (_this.gridColumnApi.getColumn(cur)) {
          acc = Object.assign(acc, _defineProperty({}, cur, gridSetting.settings.filterModel[cur]));
        }

        return acc;
      }, {});
      return gridSetting;
    };
  }
  /**
   * Function that enabled/disables pinned top toolbars
   * @param showAggRow toolbar with aggregations
   * @param showBulkRow toolbar for bulk edit
   */


  _createClass(AgGridStore, [{
    key: "setPinnedTopRows",
    value: function setPinnedTopRows(showAggRow, showBulkRow) {
      this.showAggRow = showAggRow;
      this.showBulkRow = showBulkRow;
    }
    /**
     * Function that updates validation state of data in grid
     * @param invalid valid state
     */

  }, {
    key: "setValid",
    value: function setValid(invalid) {
      this.invalid = invalid;
    }
    /**
     * Function that sets selected rows on selection chnaged
     * @param rows
     */

  }, {
    key: "setSelectedRows",
    value: function setSelectedRows(rows) {
      this.selectedRows = rows;
    }
  }, {
    key: "setGridApis",
    value: function setGridApis(gridApi, gridColumnApi, gridViewApi) {
      this.gridApi = gridApi;
      this.gridColumnApi = gridColumnApi;
      this.gridViewApi = gridViewApi;
    }
    /**
     *  Tries to find corresponding animal to supplied grid settings
     *  returns animalID
     */

  }, {
    key: "findAnimalIdByGridSetting",
    value: function findAnimalIdByGridSetting(settings) {
      // TODO: comparison of settings sometimes fails when filter value is type of array and
      // value order is mismatched, example: ["ACTIVE", "CLOSED"] vs ["CLOSED", "ACTIVE"]. This results in animal beign not selected.
      return this.gridSettings.findKey(function (s) {
        return isEqual(s.settings, settings);
      });
    }
    /** Gets default settings, find corresponding animal and set it as active */

  }, {
    key: "activateCurrentSettings",
    value: function activateCurrentSettings() {
      var _this5 = this;

      var settings = this.defaultGridSettings && this.defaultGridSettings.settings;
      var animalId = this.findAnimalIdByGridSetting(settings);

      if (animalId) {
        this.gridSettingJustChanged = true;
        runInAction(function () {
          _this5.activeGridSettingsId = animalId;
        });
      }
    }
    /** Gets current settings from grid settings */

  }, {
    key: "getCurrentSettings",
    value: function getCurrentSettings() {
      var _this6 = this;

      var animal = null;

      if (this.activeGridSettingsId) {
        animal = this.gridSettings.find(function (s) {
          return s.id === _this6.activeGridSettingsId;
        });
      }

      if (animal) {
        return animal.settings;
      } else if (this.defaultGridSettings) {
        return this.defaultGridSettings.settings;
      } else {
        return {
          columnState: this.gridColumnApi.getColumnState(),
          filterModel: this.gridApi.getFilterModel(),
          sortModel: this.gridApi.getSortModel()
        };
      }
    }
    /** Sets settings via grid api and activates corresponding animal */

  }, {
    key: "setCurrentSettings",
    value: function setCurrentSettings(settings) {
      // LOG-6632 - when current filter is set we assume it was set by getCurrentSettings so we omit triggering onColumnsSettingsChanged event.
      this.skipColumnsChangeEvent = true;
      this.gridColumnApi.setColumnState(settings.columnState);
      this.gridApi.setFilterModel(settings.filterModel);
      this.gridApi.setSortModel(settings.sortModel);
      this.activateCurrentSettings();
    }
  }]);

  return AgGridStore;
}();

export { AgGridStore as default };

__decorate([observable, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettings", void 0);

__decorate([observable, __metadata("design:type", GridSettings)], AgGridStore.prototype, "defaultGridSettings", void 0);

__decorate([observable, __metadata("design:type", String)], AgGridStore.prototype, "activeGridSettingsId", void 0);

__decorate([observable, __metadata("design:type", Boolean)], AgGridStore.prototype, "gridSettingsModalVisible", void 0);

__decorate([observable, __metadata("design:type", Boolean)], AgGridStore.prototype, "showAggRow", void 0);

__decorate([observable, __metadata("design:type", Boolean)], AgGridStore.prototype, "showBulkRow", void 0);

__decorate([observable, __metadata("design:type", Boolean)], AgGridStore.prototype, "invalid", void 0);

__decorate([observable, __metadata("design:type", Array)], AgGridStore.prototype, "selectedRows", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Boolean, Boolean]), __metadata("design:returntype", void 0)], AgGridStore.prototype, "setPinnedTopRows", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Boolean]), __metadata("design:returntype", void 0)], AgGridStore.prototype, "setValid", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", void 0)], AgGridStore.prototype, "setSelectedRows", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [GridApi, ColumnApi, GridViewApi]), __metadata("design:returntype", void 0)], AgGridStore.prototype, "setGridApis", null);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "findGridSettingsByParentId", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "createGridSettingsByParent", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingReset", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingModalNew", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingModalEdit", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingModalSubmit", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingSwitch", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "toggleGridSettingModalVisible", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingDelete", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingUpdate", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "clearGridSettings", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "checkColumnState", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingSave", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "gridSettingsLoad", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], AgGridStore.prototype, "activateCurrentSettings", null);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "onFilterChanged", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "onColumnResized", void 0);

__decorate([action, __metadata("design:type", Object)], AgGridStore.prototype, "normalizeSettings", void 0);